<template>
  <footer id="footer">
    <div class="footer-inner">
      <!-- Logo & Slogan -->
      <div class="footer-brand">
        <div class="footer-logo">
          <img src="@/assets/img/logo.svg" alt="小乐智行">
        </div>
        <p class="slogan">让智能网联与机器人教学<br/>更可视、更可控、更易落地</p>
      </div>

      <!-- Product Links -->
      <div class="footer-links">
        <h4>产品</h4>
        <ul>
          <li><router-link to="/product/sandbox">车路协同数字孪生沙盘系统</router-link></li>
          <li><router-link to="/product/deepcar">DeepCar 自动驾驶机器人</router-link></li>
          <li><router-link to="/product/deepcar-pro">DeepCar Pro 室外无人驾驶机器人</router-link></li>
          <li><router-link to="/product/v2x">路侧感知与 V2X 中控平台</router-link></li>
          <li><router-link to="/product/autosim">AutoSim 智能车仿真系统</router-link></li>
          <li><router-link to="/product/education">智慧交通教学实训方案</router-link></li>
          <li><router-link to="/product/ai-platform">一站式人工智能教学平台</router-link></li>
        </ul>
      </div>

      <!-- Company Links -->
      <div class="footer-links">
        <h4>公司</h4>
        <ul>
          <li><router-link to="/companyintroduction">关于我们</router-link></li>
          <li><router-link to="/cases">客户案例</router-link></li>
          <li><router-link to="/downloads">产品资料</router-link></li>
          <li><router-link to="/contactus">联系我们</router-link></li>
        </ul>
      </div>

      <!-- Contact Info -->
      <div class="footer-contact">
        <h4>联系方式</h4>
        <p class="contact-item">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
            <circle cx="12" cy="10" r="3"></circle>
          </svg>
          <span>北京市朝来科技园</span>
        </p>
        <p class="contact-item">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
          </svg>
          <span>18600598413</span>
        </p>
      </div>

      <!-- WeChat QR Code -->
      <div class="footer-wechat">
        <h4>扫码联系我们</h4>
        <img :src="wechatQR" alt="企业微信二维码" />
        <p class="qr-tip">添加企业微信好友</p>
      </div>
    </div>

    <!-- Copyright -->
    <div class="footer-bottom">
      <p>Copyright © 2020 - 2026 北京小乐智行科技有限公司 版权所有</p>
    </div>
  </footer>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {
      wechatQR: require('@/assets/img/wechat-qr.png')
    };
  }
};
</script>
<style scoped>
#footer {
  width: 100%;
  background: linear-gradient(180deg, #0f172a 0%, #020617 100%);
  color: #cbd5e1;
  padding: 64px 0 0;
}
.footer-inner {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
  display: grid;
  grid-template-columns: 1.5fr 1.2fr 1fr 1fr 1fr;
  gap: 48px;
}

/* Brand */
.footer-brand {
  display: flex;
  flex-direction: column;
}
.footer-logo {
  width: 160px;
  margin-bottom: 20px;
}
.footer-logo img {
  width: 100%;
  height: auto;
  filter: brightness(0) invert(1);
}
.slogan {
  font-size: 14px;
  line-height: 1.8;
  color: #94a3b8;
  margin: 0;
}

/* Links */
.footer-links h4 {
  font-size: 16px;
  font-weight: 600;
  color: #fff;
  margin: 0 0 20px 0;
}
.footer-links ul {
  list-style: none;
  margin: 0;
  padding: 0;
}
.footer-links li {
  margin-bottom: 12px;
}
.footer-links a {
  font-size: 14px;
  color: #94a3b8;
  text-decoration: none;
  transition: color 0.2s;
}
.footer-links a:hover {
  color: #0ea5e9;
}

/* Contact */
.footer-contact h4 {
  font-size: 16px;
  font-weight: 600;
  color: #fff;
  margin: 0 0 20px 0;
}
.contact-item {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  font-size: 14px;
  color: #94a3b8;
  margin-bottom: 12px;
  line-height: 1.6;
}
.contact-item svg {
  flex-shrink: 0;
  margin-top: 2px;
  color: #0ea5e9;
}

/* WeChat QR */
.footer-wechat h4 {
  font-size: 16px;
  font-weight: 600;
  color: #fff;
  margin: 0 0 20px 0;
}
.footer-wechat img {
  width: 140px;
  height: 140px;
  object-fit: contain;
  border-radius: 8px;
  background: #fff;
  padding: 8px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.2);
  transition: transform 0.3s ease;
}
.footer-wechat img:hover {
  transform: scale(1.05);
}
.qr-tip {
  font-size: 13px;
  color: #94a3b8;
  margin: 12px 0 0;
  text-align: center;
}

/* Bottom */
.footer-bottom {
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  padding: 24px 0;
  margin-top: 48px;
}
.footer-bottom p {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
  font-size: 13px;
  color: #64748b;
  text-align: center;
}

/* Responsive */
@media screen and (max-width: 997px) {
  #footer { padding: 48px 0 0; }
  .footer-inner {
    grid-template-columns: 1fr 1fr 1fr;
    gap: 32px;
  }
  .footer-brand {
    grid-column: span 3;
    margin-bottom: 16px;
  }
  .footer-wechat {
    grid-column: span 3;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 16px;
  }
  .footer-bottom { margin-top: 32px; }
}

@media screen and (max-width: 768px) {
  .footer-inner {
    grid-template-columns: 1fr;
    gap: 32px;
  }
  .footer-brand,
  .footer-wechat {
    grid-column: span 1;
    text-align: center;
  }
  .footer-logo {
    margin: 0 auto 16px;
  }
  .footer-links,
  .footer-contact {
    text-align: center;
  }
  .contact-item {
    justify-content: center;
  }
  .footer-bottom p {
    font-size: 12px;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/Footer.vue